module.exports = __webpack_public_path__ + "img/Trophy Cup Table31.058c9b88.jpg";